import { RESPONSIVE_PADDING, SCREEN_WIDTH } from 'constants/ui';

import { DrawerSize } from './DrawerCDS.constants';

export const getDrawerProps = (size = DrawerSize.STANDARD) => ({
  sx: {
    position: 'fixed',
    zIndex: 1300,
    '& .MuiDrawer-paper': {
      width: size,
      maxWidth: '100%',
      padding: RESPONSIVE_PADDING.DESKTOP,
      // On native (notched) devices the full-height drawer paper starts under the status bar /
      // Dynamic Island. Add the top safe-area to the top padding so the header/close clears it
      // (0 in a browser, so desktop is unaffected). Applied per-breakpoint since padding differs.
      paddingTop: `calc(${RESPONSIVE_PADDING.DESKTOP} + env(safe-area-inset-top, 0px))`,
      backgroundColor: ({ palette }) => palette.background.disabled,
      position: 'absolute',

      [`@media(max-width: ${SCREEN_WIDTH.M - 1}px)`]: {
        width: '100%',
        padding: RESPONSIVE_PADDING.MOBILE,
        paddingTop: `calc(${RESPONSIVE_PADDING.MOBILE} + env(safe-area-inset-top, 0px))`,
      },

      [`@media(min-width: ${SCREEN_WIDTH.M}px) and (max-width: ${SCREEN_WIDTH.L - 1}px)`]: {
        width: size === DrawerSize.STANDARD ? 'calc(100% - 100px)' : size,
        padding: RESPONSIVE_PADDING.TABLET,
        paddingTop: `calc(${RESPONSIVE_PADDING.TABLET} + env(safe-area-inset-top, 0px))`,
      },
    },
    '& .MuiBackdrop-root': {
      zIndex: 1300,
    },
  },
});

export const slideProps = {
  timeout: { enter: 150, exit: 150 },
  appear: true,
  tabIndex: 'unset',
};

export const contentStyles = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};

export const headerStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '20px',
  marginBottom: '16px',
};

export const titleStyles = {
  fontSize: '1.8rem',
  fontWeight: 600,
};

export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  boxShadow: ({ palette }) => palette.shadow.m,
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '4px',
  overflow: 'hidden',
};

export const formContentStyles = {
  display: 'flex',
  flex: 1,
  overflow: 'auto',
  padding: '24px 24px 0',
};

export const dividerStyles = {
  borderColor: ({ palette }) => palette.border.default,
};

export const controlsWrapperStyles = {
  display: 'flex',
  padding: '16px 24px',
  justifyContent: 'end',
  gap: '8px',
};

export const closeButtonStyles = {
  borderRadius: '6px',
  textTransform: 'none',
  fontSize: '1.2rem',
  boxShadow: 'none !important',
  borderColor: ({ palette }) => palette.primary.main,
};
